/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 expansion.glb --transform --simplify --ratio 0.5 --draco 
Files: expansion.glb [2.99MB] > C:\Users\eviei\Desktop\MODELOSORION\eth\expansion-transformed.glb [318.04KB] (89%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function ExpBoardSkin(pos) {
  const { nodes, materials } = useGLTF('/models/expansion2-transformed.glb')
  return (
    <group position={[pos[0],pos[1],pos[2]-2.6]} dispose={null} rotation={[0,Math.PI/2,0]}>
      <mesh geometry={nodes['20250909_EPCB0048-V01_EXP_BASE_BOARD_Without_Components004'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['20250909_EPCB0048-V01_EXP_BASE_BOARD_Without_Components004_1'].geometry} material={materials.PaletteMaterial001} /> 
    </group>
  )
}

useGLTF.preload('/models/expansion2-transformed.glb')
